module.exports = __webpack_public_path__ + "static/assets/ef1ded7e12c22605ba70f95382a96a13.png";